import React from 'react';
import { Dropdown, Icons } from '@myob/myob-widgets';
import { TableActionsWrapper } from 'modules/MyBills/components/BillingHistory/styles';
import { downloadMyBillsPdf, EBillsStatus } from 'modules/MyBills';
import { EButtonNames, openPayNowUrlInNewTab, trackClickEventInMyBills } from 'modules/MyBills/myBillsHelper';
import { useHistory } from 'react-router-dom';
import { ERoutePath } from 'router';
import { useRegionConfig } from 'hooks/useRegionConfig';
import { useDispatch } from 'react-redux';

type Props = {
    invoiceNumber: string;
    status: EBillsStatus;
    downloadId: string;
};

type TDropdownMap = {
    [key in EBillsStatus]: React.ReactElement[];
};
export const ActionDropdown: React.FC<Props> = ({ invoiceNumber, status }) => {
    const DropdownMap: TDropdownMap = {
        [EBillsStatus.Paid]: [
            <Dropdown.Item key="DownloadBill" label="Download bill" value={EButtonNames.DownloadBill} />,
        ],
        [EBillsStatus.DueNow]: [
            <Dropdown.Item key="PayNow" label="Pay now" value={EButtonNames.PayNow} />,
            <Dropdown.Item key="DownloadBill" label="Download bill" value={EButtonNames.DownloadBill} />,
            <Dropdown.Item
                key="UpdatePaymentDetails"
                label="Update payment details"
                value={EButtonNames.UpdatePaymentDetails}
            />,
        ],
        [EBillsStatus.Credited]: [
            <Dropdown.Item key="DownloadNotice" label="View notice" value={EButtonNames.ViewNotice} />,
        ],
    };
    const history = useHistory();
    const dispatch = useDispatch();

    const { PAY_INVOICE: payInvoiceUrl } = useRegionConfig();
    const actionFunctionMap: { [key in EButtonNames]: () => void } = {
        [EButtonNames.UpdatePaymentDetails]: () => {
            trackClickEventInMyBills(EButtonNames.UpdatePaymentDetails, 'BillingHistory');
            history.push(ERoutePath.PaymentProfile);
        },
        [EButtonNames.ViewNotice]: () => {
            trackClickEventInMyBills(EButtonNames.ViewNotice, 'BillingHistory');
        },
        [EButtonNames.DownloadBill]: () => {
            trackClickEventInMyBills(EButtonNames.DownloadBill, 'BillingHistory');
            dispatch(downloadMyBillsPdf(invoiceNumber));
        },
        [EButtonNames.PayNow]: () => {
            trackClickEventInMyBills(EButtonNames.PayNow, 'BillingHistory');
            openPayNowUrlInNewTab(payInvoiceUrl, invoiceNumber);
        },
    };

    const handDropdownSelection = (action: EButtonNames) => {
        actionFunctionMap[action]();
    };

    return (
        <TableActionsWrapper data-testid="actionButton">
            <Dropdown
                right
                items={DropdownMap[status]}
                onSelect={handDropdownSelection}
                toggle={
                    <Dropdown.Toggle type="clear" aria-label="more options" size="xs">
                        <Icons.More size="16px" />
                    </Dropdown.Toggle>
                }
            />
        </TableActionsWrapper>
    );
};
